import React, { useContext, useEffect, useState } from "react";
import "../../Dashboard/View_List/View_List.css";
import Add from "./Add";
import Edit from "./Edit";
import Delete_Points_Modal from "../../Common_Component/Common_Modal/Delete_Points_Modal/Delete_Points_Modal";
import { Button, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  findAll,
  Delete,
  Status,
} from "../../../utils/apis/rummy/rummy_table_points/index";
import { Per_Page_Dropdown } from "../../../utils/common";
import Pagination_holder from "../../Common_Component/Pagination_holder/Pagination_holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import { Context } from "../../../utils/context";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";

const Tables = () => {
  const { UnauthorizedLogOut, IMG_URL, isAllow } = useContext(Context);

  const [modalShow, setModalShow] = useState(false);
  const [modalEditShow, setModalEditShow] = useState(0);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(10);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();

  const getDataAll = async () => {
    try {
      const response = await findAll(currentPage, perPage, search);
      await setData(response?.data);
      setCurrentPage(response?.data?.data?.current_page);
      setperPage(response?.data?.data?.per_page);
      setSearch(response?.data?.data?.search_name);

      setOption(await Per_Page_Dropdown(response?.data?.data?.total));
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, modalShow, modalEditShow, currentPage]);

  const StatusChange = async (id) => {
    const response = await Status(id);
    setChangeStatus(response);
  };

  const handleDeleteRecord = async () => {
    setModalDeleteShow(false);
    if (recordToDeleteId) {
      const response = await Delete(recordToDeleteId);

      await setShowModal({
        code: response.data.code,
        message: response.data.data,
      });

      setTimeout(() => {
        setShowModal(0);
      }, 2000);
      setRecordToDeleteId(null);
      setChangeStatus(response);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"Rummy Table Points"} />
        <div className="search-bar-holder ">
          <Form>
            <div className="row align-items-end">
              {isAllow?.includes(69) && (
                <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5  col-holder">
                  <Button
                    type="button"
                    className="search-btn"
                    onClick={() => setModalShow(true)}>
                    Add
                  </Button>
                </div>
              )}

              {/* <div className=" col-12 mt-3">
                <div className="d-flex  align-items-center">
                  <div className="show me-2">
                    <p style={{ color: "white" }} className="show m-0">
                      Show
                    </p>
                  </div>
                  <div className="number me-2">
                    <select
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                      onChange={(e) => setperPage(e.target.value)}
                    >
                      {option?.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="entries">
                    <p style={{ color: "white" }} className="show m-0">
                      entries
                    </p>
                  </div>

                  <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-6 col-sm-2 col-12">
                    <div className="sowing me-2 ms-5">
                      <p
                        style={{ color: "white" }}
                        className="show m-0"
                      >{`Showing ${Math.min(
                        (currentPage - 1) * perPage + 1
                      )} to ${Math.min(
                        currentPage * perPage,
                        data?.data?.total
                      )} of ${data?.data?.total} entries`}</p>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </Form>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="user-list-table">
              {/* <Banner_List_Table /> */}

              <div className="data-table-holder">
                <Table responsive bordered striped>
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Points</th>
                      <th>1st Round Drop Points</th>
                      <th>Max Lose Points</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data?.data?.data?.map((d, index) => {
                      return (
                        <tr>
                          <td>{(currentPage - 1) * perPage + index + 1}</td>
                          <td> {d?.name}</td>
                          <td> {d?.drop_points}</td>
                          <td> {d?.max_lose_points}</td>
                          <td>
                            <div className="d-flex justify-content-center">
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  checked={d.status}
                                  onChange={() => {
                                    StatusChange(d.id);
                                  }}
                                  id={`flexSwitchCheckDefault${d?.id}`}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`flexSwitchCheckDefault${d?.id}`}>
                                  {d.status ? "Active" : "Inactive"}
                                </label>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="action-holder">
                              {isAllow?.includes(70) && (
                                <div
                                  className="icon-holder"
                                  onClick={() => setModalEditShow(d?.id)}>
                                  <FontAwesomeIcon icon={faPenToSquare} />
                                </div>
                              )}

                              {isAllow?.includes(71) && (
                                <div
                                  className="icon-holder"
                                  onClick={() => {
                                    setRecordToDeleteId(d?.id);
                                    setModalDeleteShow(true);
                                  }}>
                                  <FontAwesomeIcon icon={faTrash} />
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <CustomPaginate
                  currentPage={data?.data?.current_page}
                  totalPages={data?.data?.total_pages}
                  handlePageChange={handlePageChange}
                />
                {/* <Heading_Holder subtext={"Note:"} /> */}

                <Heading_Holder
                  headingText={
                    "NOTE : After 1 Round +10 points will be applicable on 1st Round Drop Points"
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Add show={modalShow} onHide={() => setModalShow(false)} />

      <Edit show={modalEditShow} onHide={() => setModalEditShow(false)} />

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />

      <Delete_Points_Modal
        show={modalDeleteShow}
        handleDeleteRecord={handleDeleteRecord}
        onHide={() => setModalDeleteShow(false)}
      />
    </>
  );
};

export default Tables;
